const ibanReplaceLetters = (str) => {
    return str.replace(/[A-Z]/g, ch => String(ch.charCodeAt(0) - 55));
};
const validateIban = (value) => {
    if (value === null || value === undefined || value === '')
        return true;
    const cleaned = value.replace(/[^0-9a-zA-Z]/g, '');
    if (cleaned.length <= 4)
        return false;
    if (cleaned.substring(0, 2).toUpperCase() === 'BE' && cleaned.length !== 16)
        return false;
    const toTest = cleaned.substring(4) + cleaned.substring(0, 4);
    const numeric = ibanReplaceLetters(toTest.toUpperCase());
    let remainder = '';
    let chunk = numeric;
    while (chunk.length > 9) {
        const numTest = remainder + chunk.substring(0, 9);
        chunk = chunk.substring(9);
        remainder = String(parseInt(numTest, 10) % 97);
    }
    const finalNum = remainder + chunk;
    return parseInt(finalNum, 10) % 97 === 1;
};
export default validateIban;
